import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Prefectures,
  CommonOrCommonRetirementFlug,
  DepositType,
  FormKbn,
  FormClassRetire,
  DemanderKbn,
  DemanderRelationship,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  changeZipcodeFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import {
  funStatusBodyList,
  fundownloadBodyList,
} from "./../SCRW410005/hooks/useHooks";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_RET004, httpAPI_COM014 } from "./api/request";
import { fakeTableList, fileDisplayMap, headList, schema } from "./parts";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import _ from "lodash";
import { FormList } from "../../type/apiType/IAPI_RET004";

/**
 * SCRW410005 退職手当金受領者の変更手続き（登録内容の確認）
 * @return SCRW410005 退職手当金受領者の変更手続き（登録内容の確認）
 */
const SCRW410005 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location?.state;
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [downloadedFileMap, setDownloadedFileMap] = useState<
    Record<string, string>
  >({});
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { state: businessState } = useContext<any>(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [status, setStatus] = useState<any>();
  const [statusBodyList, setStatusBodyList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [resRetirementStaffName, setResRetirementStaffName] = useState<any>("");
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("1");
  const applyId = locationState?.applyId ?? businessState?.job_41?.applyId;

  const getDownloadCacheKey = (item: any) => {
    return `${applyId ?? ""}_${item.formKbn ?? ""}_${item.formClass ?? ""}`;
  };

  const handleInit = async () => {
    try {
      const res = await httpAPI_RET004({
        applyId: applyId,
        contractorNo: businessState?.common?.contractorNo,
      });

      let resArr = stateFakeTableListRef.current;

      setStatus(res.latestApplyStatus);
      setCorpApplyKbn(res.corpApplyKbn);
      setResRetirementStaffName(res.retirementStaffName);

      // 初期表示
      resArr.find((item) => item.keyword === "demanderNameKana")!.text =
        res.demanderNameKana;
      resArr.find((item) => item.keyword === "demanderName")!.text =
        res.demanderName;

      resArr.find((item) => item.keyword === "demanderBirth")!.text =
        res.demanderBirth;

      resArr.find((item) => item.keyword === "demanderZipcode")!.text =
        changeZipcodeFormat(res.demanderZipcode);

      if (
        res.demanderPrefectureCd !== undefined &&
        !isNaN(Number(res.demanderPrefectureCd))
      ) {
        resArr.find((item) => item.keyword === "locationGroup")!.text =
          (TkGetCode(Prefectures, res.demanderPrefectureCd) ?? "") +
          (res.demanderCity ?? "") +
          (res.demanderAddressOthers ?? "");
      }
      resArr.find((item) => item.keyword === "tel")!.text = res.tel;

      resArr.find((item) => item.keyword === "demanderEmail")!.text =
        res.demanderEmail;

      resArr.find((item) => item.keyword === "agentEmail")!.text =
        res.agentEmail;

      resArr.find((item) => item.keyword === "bankCd")!.text = res.bankCd;

      resArr.find((item) => item.keyword === "bankName")!.text = res.bankName;

      resArr.find((item) => item.keyword === "branchCd")!.text = res.branchCd;

      resArr.find((item) => item.keyword === "branchName")!.text =
        res.branchName;

      resArr.find((item) => item.keyword === "depositType")!.text = TkGetCode(
        DepositType,
        res.depositType
      );

      resArr.find((item) => item.keyword === "accountNo")!.text = res.accountNo;

      resArr.find((item) => item.keyword === "accountNameKana")!.text =
        res.accountNameKana;

      //「死亡診断書」又は「死体検案書」（写）
      let deathOrAutopsyReport = resArr.find(
        (item) => item.keyword === "deathOrAutopsyReport"
      )!;

      //職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）
      let yesLivelihoodInvestForm = resArr.find(
        (item) => item.keyword === "yesLivelihoodInvestForm"
      )!;

      //職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号
      let noLivelihoodInvestForm = resArr.find(
        (item) => item.keyword === "noLivelihoodInvestForm"
      )!;

      //内縁関係についての「生計維持に関する調査書」（様式１１号）
      let marriageReport = resArr.find(
        (item) => item.keyword === "marriageReport"
      )!;

      //職員の死亡を証する「戸籍謄本」又は「除籍謄本」
      let certifiedCertificateResidence = resArr.find(
        (item) => item.keyword === "certifiedCertificateResidence"
      )!;

      //その他、事実上の配偶者であることを証明する書類
      let claimantPartnerBook = resArr.find(
        (item) => item.keyword === "claimantPartnerBook"
      )!;

      //確認する書類の選択
      let identifyDocsKind = resArr.find(
        (item) => item.keyword === "identifyDocsKind"
      )!;
      identifyDocsKind.setDefaultValue = res.identificationDocsKind;

      //死亡した退職者の個人番号を確認する書類
      let deceasedRetireeNumCheckDoc = resArr.find(
        (item) => item.keyword === "deceasedRetireeNumCheckDoc"
      )!;

      //個人番号を確認する書類
      let numberCheckDoc = resArr.find(
        (item) => item.keyword === "numberCheckDoc"
      )!;

      //振込先口座が確認できる書類
      let payAccountCheckDoc = resArr.find(
        (item) => item.keyword === "payAccountCheckDoc"
      )!;

      const showFile = (key: string, file: FormList) => {
        if (fileDisplayMap[key].includes(res.identificationDocsKind!)) {
          let target = resArr.find((item) => item.keyword === key)!;
          target.showLine = true;
          target.dataname = file.formName;
          target.base64filedata = file?.file;
          try {
            // ダウンロード時にAPI経由で取得するハンドラを設定し、コンポーネント側の自動ダウンロードを無効化
            target.onClick = (info: any) => fetchAndDownload(info, file);
            target.downloadBase64 = false;
          } catch (e) {}
        }
      };

      res.fileList?.forEach((file) => {
        if (file.formKbn !== FormKbn["退職書類"]) return;

        switch (file.formClass) {
          case FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]:
            deathOrAutopsyReport.showLine = true;
            deathOrAutopsyReport.base64filedata = file.file;
            deathOrAutopsyReport.dataname = file.formName;
            try {
              deathOrAutopsyReport.onClick = (info: any) =>
                fetchAndDownload(info, file);
              deathOrAutopsyReport.downloadBase64 = false;
            } catch (e) {}
            break;
          case FormClassRetire["生計維持に関する調査書（様式11号）"]:
            if (
              res.demanderRelationship ===
              DemanderRelationship["内縁の妻又は夫"]
            ) {
              marriageReport.showLine = true;
              marriageReport.base64filedata = file.file;
              marriageReport.dataname = file.formName;
              try {
                marriageReport.onClick = (info: any) =>
                  fetchAndDownload(info, file);
                marriageReport.downloadBase64 = false;
              } catch (e) {}
            } else if (
              res.demanderRelationship === DemanderRelationship["子ども"] ||
              res.demanderRelationship === DemanderRelationship["その他"]
            ) {
              if (res.livelihoodFromRetireeFlg === "1") {
                yesLivelihoodInvestForm.showLine = true;
                yesLivelihoodInvestForm.base64filedata = file.file;
                yesLivelihoodInvestForm.dataname = file.formName;
                try {
                  yesLivelihoodInvestForm.onClick = (info: any) =>
                    fetchAndDownload(info, file);
                  yesLivelihoodInvestForm.downloadBase64 = false;
                } catch (e) {}
              } else {
                noLivelihoodInvestForm.showLine = true;
                noLivelihoodInvestForm.base64filedata = file.file;
                noLivelihoodInvestForm.dataname = file.formName;
                try {
                  noLivelihoodInvestForm.onClick = (info: any) =>
                    fetchAndDownload(info, file);
                  noLivelihoodInvestForm.downloadBase64 = false;
                } catch (e) {}
              }
            }
            break;
          case FormClassRetire["職員の死亡当時の住民票の謄本"]:
            certifiedCertificateResidence.showLine = true;
            certifiedCertificateResidence.base64filedata = file.file;
            certifiedCertificateResidence.dataname = file.formName;
            try {
              certifiedCertificateResidence.onClick = (info: any) =>
                fetchAndDownload(info, file);
              certifiedCertificateResidence.downloadBase64 = false;
            } catch (e) {}
            break;
          case FormClassRetire["事実上の配偶者であることを証明する書類"]:
            claimantPartnerBook.showLine = true;
            claimantPartnerBook.base64filedata = file.file;
            claimantPartnerBook.dataname = file.formName;
            try {
              claimantPartnerBook.onClick = (info: any) =>
                fetchAndDownload(info, file);
              claimantPartnerBook.downloadBase64 = false;
            } catch (e) {}
            break;
          case FormClassRetire["本人確認書類"]:
            if (
              resArr.find((item) => item.keyword === "identityDocs1")!.showLine
            ) {
              showFile("identityDocs2", file);
            } else {
              showFile("identityDocs1", file);
            }
            break;
          case FormClassRetire["本人確認書類（表面）"]:
            showFile("identityDocHead", file);
            break;
          case FormClassRetire["本人確認書類（裏面）"]:
            showFile("identityDocTail", file);
            break;
          case FormClassRetire["個人番号を確認する書類"]:
            numberCheckDoc.showLine = true;
            numberCheckDoc.base64filedata = file.file;
            numberCheckDoc.dataname = file.formName;
            try {
              numberCheckDoc.onClick = (info: any) =>
                fetchAndDownload(info, file);
              numberCheckDoc.downloadBase64 = false;
            } catch (e) {}
            break;
          case FormClassRetire["振込先口座が確認できる書類"]:
            payAccountCheckDoc.showLine = true;
            payAccountCheckDoc.base64filedata = file.file;
            payAccountCheckDoc.dataname = file.formName;
            try {
              payAccountCheckDoc.onClick = (info: any) =>
                fetchAndDownload(info, file);
              payAccountCheckDoc.downloadBase64 = false;
            } catch (e) {}
            break;
          case FormClassRetire["死亡した退職者の個人番号を確認する書類"]:
            if (res.demanderKbn === DemanderKbn["遺族"]) {
              deceasedRetireeNumCheckDoc.showLine = true;
              deceasedRetireeNumCheckDoc.base64filedata = file.file;
              deceasedRetireeNumCheckDoc.dataname = file.formName;
              try {
                deceasedRetireeNumCheckDoc.onClick = (info: any) =>
                  fetchAndDownload(info, file);
                deceasedRetireeNumCheckDoc.downloadBase64 = false;
              } catch (e) {}
            }
            break;
        }
      });

      // クリック時にファイルを取得してダウンロードするハンドラ
      const fetchAndDownload = async (
        clickInfo: any,
        item: any,
        applyIdParam?: any
      ) => {
        try {
          const cacheKey = getDownloadCacheKey(item);
          // 既にファイルがあれば再利用
          let fileBase64 =
            downloadedFileMap[cacheKey] ?? item.file ?? item.fileBase64 ?? null;

          if (!fileBase64) {
            // API 呼び出し
            const res: any = await httpAPI_COM014({
              applyId:
                applyIdParam ?? applyId ?? businessState?.job_41?.applyId,
              formKbn: item.formKbn,
              formClass: item.formClass,
            });

            if (res.resultCd === "I0000") {
              // サーバ側が file を直接返す場合と、formList を返す場合に対応
              fileBase64 =
                res.fileBase64 ??
                (res.formList &&
                  res.formList[0] &&
                  res.formList[0].fileBase64) ??
                null;

              if (fileBase64) {
                setDownloadedFileMap((prev) => ({
                  ...prev,
                  [cacheKey]: fileBase64,
                }));
              } else {
                // 正常結果だがファイルが無い場合
                setState({
                  ...state,
                  errorMsgId: "W3000",
                });
                return;
              }
            } else {
              setState({
                ...state,
                errorMsgId: res.resultCd,
              });
              return;
            }
          }

          // ダウンロード処理（base64 -> Blob -> ダウンロード）
          if (fileBase64) {
            const mimeMatch = fileBase64.match(/^data:(.*?);base64,/);
            const mimeType = mimeMatch
              ? mimeMatch[1]
              : "application/octet-stream";
            const base64Data = fileBase64.replace(/^data:.*;base64,/, "");

            const extension = mimeType ? "." + mimeType.split("/")[1] : "";
            let fileName = item.formName ?? item.fileName ?? "file";
            fileName = fileName.includes(".") ? fileName : fileName + extension;

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length)
              .fill(null)
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });

            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.target = "_blank";
            link.rel = "nofollow noopener noreferrer";
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          }
        } catch (error) {
          navigate("/error");
        }
      };

      const downloadBodyList = fundownloadBodyList(res);
      setBodyList(downloadBodyList);

      const statusList = funStatusBodyList(res.memoList);

      setStatusBodyList(statusList);
      setStateTableList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const data: IAPI_APP016_Request = {
      applyId: applyId,
      applyEvent: num,
      contractorNo: businessState?.common?.contractorNo,
      inquiryCode: memoCheck ? "3" : undefined,
      screenId: "SCRW410005",
      reason: memoData,
    };
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData?.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }

    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  return (
    <Box className="SCRW410005" data-testid="SCRW410005PageForTest">
      <Box>
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-41"
          applicationStatus={status}
          corporateApplicationClassification={corpApplyKbn}
        />
      </Box>

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW410005_01}</TkInfoManual>
      <Box>
        {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
          <TkContractorAndNumberLine
            name="退職者名"
            no={resRetirementStaffName}
          />
        )}

        <TkFakeTable
          list={stateTableList}
          ruleSchema={schema}
          showButton={false}
        />

        <TkMemo
          bodyList={statusBodyList}
          showTable={true}
          onChange={onChange}
        />

        {isStatusAfterApproval(status) && (
          <TkTableWithNoLine headList={headList} bodyList={bodyList} />
        )}

        <Box className="btn">
          <TkBackButton className="tkBottonMr" />
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            onClick={btnEvent}
          />
        </Box>

        <TkApprovalDateSymbolNumberRegistrationDialog
          data-testid="SCRW410005PageForDialog"
          open={isOpen}
          onSuccess={(e: any) => handleSave(e)}
          onClose={setOpen}
        />
      </Box>
    </Box>
  );
};

export default SCRW410005;
